const featuredHover = {
  links: document.querySelectorAll(
    '.jsFeaturedSingle',
  ) as NodeListOf<HTMLElement>,
  showcases: document.querySelectorAll(
    '.jsFeaturedShowcase',
  ) as NodeListOf<HTMLElement>,
  prevLevel: document.querySelectorAll(
    '.jsProdPrevLevel',
  ) as NodeListOf<HTMLElement>,
  overlay: document.getElementById('overlay') as HTMLElement,
  filtersMenu: document.querySelectorAll(
    '.jsProdLastLevel',
  ) as NodeListOf<HTMLElement>,
  activeIndex: -1,
  isHoverActive: false,
  isBlocked: false,

  init() {
    this.setupEventListeners();
  },

  setupEventListeners() {
    const prodTab = document.querySelectorAll('.jsProdTab');

    prodTab.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.setHover();
        this.setInitialActiveClass();
      });
    });

    this.links.forEach((item, index) => {
      const nextLevelLink = item.querySelector('.jsProdLink');
      if (nextLevelLink) {
        nextLevelLink.addEventListener('mouseenter', () => {
          if (this.isBlocked) return;
          this.activateSection(index);
        });
      }
    });

    this.prevLevel.forEach((item) => {
      item.addEventListener('click', () => {
        this.isBlocked = true;
        this.removeHover();

        setTimeout(() => {
          this.isBlocked = false;
        }, 300);
      });
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.filtersMenu.forEach((menu) => {
          menu.classList.remove('activeClass');
        });
        this.removeHover();
      });
    }
  },

  setHover() {
    if (this.isHoverActive) return;
    this.isHoverActive = true;
  },

  activateSection(index: number) {
    if (this.activeIndex === index) return;

    if (this.activeIndex !== -1) {
      this.showcases[this.activeIndex].classList.remove('activeClass');
    }

    this.showcases[index].classList.add('activeClass');
    this.activeIndex = index;
  },

  setInitialActiveClass() {
    const firstShowcase = this.showcases[0];
    if (firstShowcase) {
      firstShowcase.classList.add('activeClass');
      this.activeIndex = 0;
    }
  },

  removeHover() {
    this.isHoverActive = false;
    this.showcases.forEach((showcase) => {
      showcase.classList.remove('activeClass');
    });
    this.activeIndex = -1;
  },
};

export default featuredHover;
